module.exports = __webpack_public_path__ + "img/04.2.61e62755.jpg";